import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Stack,
  List,
  ListItem,
  HStack,
  Text,
  ModalCloseButton,
  VStack,
} from "@chakra-ui/react";
import Button from "components/Button/Button";
import { useState, useEffect } from "react";
import { deduction, volume } from "util/utils";

import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";

// const toUpperCase = (val) => String(val).toUpperCase();

const ForStep1 = ({ state }) => {
  // const mapSrcUnitField = (type) => {
  //   const buyMap = {
  //     sell: "destinationUnit",
  //     buy: "sourceUnit",
  //   };
  //   return state[buyMap[type]];
  // };

  const listingTypeMap = {
    buy: "destinationUnit",
    sell: "sourceUnit",
  };

  const mapSrcUnitField = (type) => {
    const buyMap = {
      sell: "destinationUnit",
      buy: "sourceUnit",
    };

    // const map = {
    //   buy: buyMap,
    //   sell: listingTypeMap,
    // };
    // return state[map[type][type]];

    console.log("CURRENCY", state?.sourceUnit);

    return state[buyMap[type]];
  };

  // const mapDestUnitField = (type) => {
  //   const sellMap = {
  //     sell: "sourceUnit",
  //     buy: "destinationUnit",
  //   };
  //   return state[sellMap[type]];
  // };

  const mapDestUnitField = (type) => {
    const sellMap = {
      sell: "sourceUnit",
      buy: "destinationUnit",
    };

    const map = {
      sell: listingTypeMap,
      buy: sellMap,
    };

    return state[map[type][type]];
  };

  const getFee = () => {
    // if (state.type === "sell")
    return (state?.volume && deduction(state.volume)) ?? "0.00";
    // return "0.00";
  };

  const getVolume = () => {
    if (state.type === "sell")
      return (state?.volume && volume(state.volume)) ?? "0";
    return state?.volume ?? "0";
  };

  return (
    <Stack>
      <List>
        <ListItem>
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Coin:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {toCoinLocale(mapDestUnitField(state.type))}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="10px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Price:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {state.dynamic
                ? "Dynamic to the market value"
                : `${String(
                    Number(state.unitCost).toFixed(2)
                  ).toLocaleString()} ${toCoinLocale(
                    mapSrcUnitField(state.type)
                  )} / 1 ${toCoinLocale(mapDestUnitField(state.type))}`}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="10px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Amount seller sees:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {state.dynamic
                ? "Dynamic to the market value"
                : `${String(
                    Number(state.unitCost).toFixed(2)
                  ).toLocaleString()} ${toCoinLocale(
                    mapSrcUnitField(state.type)
                  )} / 1 ${toCoinLocale(mapDestUnitField(state.type))}`}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="10px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Fees:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {/* 0.001 BTC */}
              {toPrecision(+getFee(), mapDestUnitField(state.type))}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="10px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Coin amount:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {toPrecision(+getVolume(), mapDestUnitField(state.type))}
              {/* {`${getVolume()} ${
                mapDestUnitField(state.type) === "cusd"
                  ? "cUSD"
                  : toUpperCase(mapDestUnitField(state.type))
              }`} */}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="10px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Limit:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {`${toPrecision(
                +state.minimumFilling ?? 0,
                mapDestUnitField(state.type)
              )} min`}{" "}
              -{" "}
              {`${toPrecision(
                +state.maximumFilling ?? 0,
                mapDestUnitField(state.type)
              )} max`}
              {/* {`${Number(state.minimumFilling)} ${
                mapDestUnitField(state.type) === "cusd"
                  ? "cUSD"
                  : toUpperCase(mapDestUnitField(state.type))
              } min - ${Number(state.maximumFilling)} ${
                mapDestUnitField(state.type) === "cusd"
                  ? "cUSD"
                  : toUpperCase(mapDestUnitField(state.type))
              } max`} */}
            </Text>
          </HStack>
        </ListItem>
        {state?.totalCost && (
          <ListItem mt="10px">
            <HStack>
              <Text color="#4E4B66" fontSize="sm">
                Total coin value:
              </Text>
              <Text color="#14142B" fontSize="sm">
                {Number(state.totalCost).toLocaleString()}{" "}
                {toCoinLocale(mapSrcUnitField(state.type))}
              </Text>
            </HStack>
          </ListItem>
        )}
      </List>
    </Stack>
  );
};

const ForStep2 = ({ state }) => {
  const paymentMethodsMap = {
    bankTransfer: { name: "Bank Transfer", color: "#F4B740" },
    changeraId: { name: "Changera", color: "#3B5C9D" },
    bitmamaWallet: { name: "Bitmama Wallet", color: "#04822D" },
  };

  const getMethodNames = () => {
    let names = [];
    state.methods.forEach((method) =>
      names.push(paymentMethodsMap[method].name)
    );
    return names.join(", ");
  };

  return (
    <Stack>
      <List>
        <ListItem>
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Payment methods:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {getMethodNames()}
            </Text>
          </HStack>
        </ListItem>
        <ListItem mt="10px">
          <HStack>
            <Text color="#4E4B66" fontSize="sm">
              Time limit:
            </Text>
            <Text color="#14142B" fontSize="sm">
              {`${state.timeout} mins`}
            </Text>
          </HStack>
        </ListItem>
      </List>
    </Stack>
  );
};

const ForStep3 = ({ state }) => {
  return (
    <Stack>
      <List>
        <ListItem>
          <VStack alignItems="flex-start">
            <Text color="#4E4B66" fontSize="sm">
              Listing terms:
            </Text>
            <Text
              color="#14142B"
              fontSize="sm"
              maxW="100%"
              whiteSpace="wrap"
              overflow="hidden"
              textOverflow="ellipsis"
              maxH="100px"
            >
              {state.terms ?? "No listing terms"}
            </Text>
          </VStack>
        </ListItem>
        <ListItem mt="10px">
          <VStack alignItems="flex-start">
            <Text color="#4E4B66" fontSize="sm">
              Listing Instructions:
            </Text>
            <Text
              color="#14142B"
              fontSize="sm"
              maxW="100%"
              whiteSpace="wrap"
              overflow="hidden"
              textOverflow="ellipsis"
              maxH="100px"
            >
              {state.instructions ?? "No listing instructions"}
            </Text>
          </VStack>
        </ListItem>
      </List>
    </Stack>
  );
};

const ListingPreview = ({
  isOpen,
  onClose,
  state,
  onConfirm,
  isLoading,
  title,
  forUpdate,
  buttonText,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const maxStep = 3;

  const previewMap = (step) => {
    const map = {
      0: <ForStep1 state={state} />,
      1: <ForStep2 state={state} />,
      2: <ForStep3 state={state} />,
    };

    return map[step];
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    } else {
      onClose();
    }
  };

  const handleNext = () => {
    if (currentStep < maxStep - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onConfirm && onConfirm();
    }
  };

  useEffect(() => setCurrentStep(0), [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#F8F9FD" overflow="hidden" borderRadius="16px">
        <ModalHeader p="26px 0" textAlign="center" bg="white" fontSize="md">
          {title}
        </ModalHeader>
        <ModalCloseButton
          top="23px"
          right="20px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
        />
        <ModalBody p="24px 48px">{previewMap(currentStep)}</ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            minW="120px"
            disabled={isLoading}
            onClick={handlePrev}
            bg="transparent"
            border="2px solid transparent"
            color="#03A438"
          >
            {currentStep <= 0
              ? buttonText && buttonText[0]
                ? buttonText[0]
                : "Close"
              : "Back"}
          </Button>
          <Button
            disabled={isLoading}
            isLoading={isLoading}
            minW="120px"
            onClick={handleNext}
          >
            {currentStep === maxStep - 1
              ? forUpdate
                ? "Update"
                : buttonText && buttonText[1]
                ? buttonText[1]
                : "Create"
              : "Next"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ListingPreview;
